<template>
  <div id="app" :class="{'desktop-device': isDesktop}">
    <router-view></router-view>
    <Footer/>
    
    <!-- 桌面端提示 -->
    <div v-if="isDesktop" class="desktop-tip">
      <span> 手机版页面</span>
    </div>
  </div>
</template>

<script>
import Footer from './common/Footer'
export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status: 0,
      isDesktop: false
    };
  },
  methods: {
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        // 登录校验已关闭
        // if(!localStorage.getItem('token')){
        //   this.$router.push({path:'/Home'})
        // }
        this.$store.commit('setBaseInfoValue', res.data);
      })
    },
    
    /**detectDeviceType() {
      const userAgent = navigator.userAgent;
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
      this.isDesktop = !isMobile && window.innerWidth > 768;
      
      // 添加到 body 类名，用于 CSS 控制
      if (this.isDesktop) {
        document.body.classList.add('desktop-device');
      } else {
        document.body.classList.remove('desktop-device');
      }
    },
    
    /**
     * 处理窗口大小变化
     */
    handleResize() {
      this.detectDeviceType();
    }
  },
  created(){
    this.getBaseInfo();
  },
  mounted() {
    // 初始设备检测
    this.detectDeviceType();
    
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 清理事件监听
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style>
/* 基础样式 */
body .van-toast {
  font-size: 1.1rem;
  padding: 1rem;
  line-height: 1.3rem;
  width: 10rem;
}
body .van-toast .van-toast__icon {
  font-size: 1.3rem;
}
*, :after, :before {
  box-sizing: border-box;
}

/* ===== 电脑端样式 - 强制显示为手机样式 ===== */
body.desktop-device {
  background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%) !important;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px 0;
  margin: 0;
  overflow-x: hidden;
}

body.desktop-device #app {
  width: 430px;
  min-height: 932px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.3),
    0 0 0 1px rgba(255, 255, 255, 0.1) inset;
  position: relative;
}

/* 超大屏幕优化 */
@media (min-width: 1440px) {
  body.desktop-device {
    padding: 40px 0;
  }
  
  body.desktop-device #app {
    border: 8px solid rgba(255, 255, 255, 0.1);
  }
}

/* ===== 移动端样式 ===== */
body:not(.desktop-device) #app {
  width: 100%;
  max-width: 100%;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

/* ===== 桌面端提示样式 ===== */
.desktop-tip {
  position: fixed;
  top: 20px;
  right: 20px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  z-index: 10000;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  animation: fadeIn 0.5s ease-in;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* ===== 确保页面内容在电脑端正确显示 ===== */
body.desktop-device .index,
body.desktop-device .home-page,
body.desktop-device .page-container {
  width: 100% !important;
  max-width: 100% !important;
  border-radius: 0 !important;
}

/* 修复导航栏在电脑端的圆角 */
body.desktop-device .van-nav-bar {
  border-radius: 20px 20px 0 0 !important;
}

/* 修复轮播图在电脑端的显示 */
body.desktop-device .banner.banners {
  border-radius: 0 !important;
}

/* 修复底部导航在电脑端的显示 */
body.desktop-device .footer-nav {
  border-radius: 0 0 20px 20px !important;
}

/* ===== 响应式优化 ===== */
@media (max-width: 430px) {
  body.desktop-device #app {
    width: 100%;
    border-radius: 0;
    margin: 0;
  }
}

/* 小屏幕手机优化 */
@media (max-width: 375px) {
  body:not(.desktop-device) #app {
    width: 100%;
  }
}

/* 超小屏幕优化 */
@media (max-width: 320px) {
  body:not(.desktop-device) #app {
    width: 100%;
  }
}

/* 无障碍访问支持 */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
  
  .desktop-tip {
    animation: none;
  }
}
</style>